import { motion, AnimatePresence } from 'framer-motion';

const ConfirmDialog = ({ 
  isOpen, 
  title, 
  message, 
  confirmText = 'Confirm', 
  cancelText = 'Cancel',
  onConfirm, 
  onCancel,
  type = 'warning' // warning, danger, info
}) => {
  const getIcon = () => {
    switch (type) {
      case 'danger':
        return 'fas fa-exclamation-triangle text-red-500';
      case 'info':
        return 'fas fa-info-circle text-blue-500';
      case 'success':
        return 'fas fa-check-circle text-green-500';
      default:
        return 'fas fa-exclamation-triangle text-yellow-500';
    }
  };

  const getConfirmButtonClass = () => {
    switch (type) {
      case 'danger':
        return 'bg-red-600 hover:bg-red-700 focus:ring-red-200';
      case 'info':
        return 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-200';
      case 'success':
        return 'bg-green-600 hover:bg-green-700 focus:ring-green-200';
      default:
        return 'bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-200';
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white/95 backdrop-blur-xl rounded-2xl p-6 max-w-md w-full shadow-2xl border border-white/20"
          >
            <div className="flex items-center mb-4">
              <i className={`${getIcon()} text-2xl mr-3`}></i>
              <h3 className="text-lg font-bold text-gray-900">{title}</h3>
            </div>
            
            <p className="text-gray-600 mb-6">{message}</p>
            
            <div className="flex gap-3">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={onCancel}
                className="flex-1 bg-gray-500 text-white py-2 px-4 rounded-lg font-medium hover:bg-gray-600 transition-colors"
              >
                {cancelText}
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={onConfirm}
                className={`flex-1 text-white py-2 px-4 rounded-lg font-medium transition-colors focus:ring-4 ${getConfirmButtonClass()}`}
              >
                {confirmText}
              </motion.button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ConfirmDialog;